export const COPY_RIGHT = `${new Date().getFullYear()} Goodrescue24 Co., Ltd. All Rights Reserved.`;
